/* VORA Landingpage – E-Mail-Anmeldung 10 % (Klaviyo-Liste TTYArG -> Welcome Flow mit WILLKOMMEN10) */
(function () {
  if (window.__voraNl) return;
  window.__voraNl = true;
  var COMPANY = 'TnEyfH', LIST = 'TTYArG';

  function build() {
    var grid = document.querySelector('#angebot .g3');
    if (!grid || document.querySelector('.vora-nl')) return;
    var box = document.createElement('div');
    box.className = 'vora-nl';
    box.style.cssText = 'max-width:640px;margin:40px auto 0;background:#fff;border:2px solid #FF85C8;border-radius:24px;padding:26px 20px;text-align:center;box-sizing:border-box';
    box.innerHTML =
      '<div style="font-weight:800;font-size:22px;line-height:1.25">10 % auf deine erste Bestellung 🎁</div>' +
      '<p style="font-size:16px;margin:8px 0 16px">Trag deine E-Mail ein und bekomm deinen Code direkt ins Postfach.</p>' +
      '<form class="vora-nl-form" novalidate style="display:flex;gap:10px;flex-wrap:wrap;justify-content:center;margin:0">' +
        '<input type="email" name="email" required autocomplete="email" placeholder="Deine E-Mail-Adresse" aria-label="E-Mail-Adresse" style="flex:1 1 240px;min-width:0;height:52px;border:1px solid #ccc;border-radius:999px;padding:0 20px;font-size:16px;box-sizing:border-box;background:#fff;color:#000">' +
        '<button type="submit" style="flex:1 1 160px;height:52px;border:0;border-radius:999px;padding:0 24px;font-size:16px;font-weight:800;background:#FF008D;color:#fff;cursor:pointer">10 % SICHERN</button>' +
      '</form>' +
      '<p class="vora-nl-msg" role="status" style="font-size:15px;font-weight:700;margin:12px 0 0;display:none"></p>' +
      '<p style="font-size:12px;color:#666;margin:12px 0 0">Mit deiner Anmeldung erhältst du E-Mails von VORA. Abmeldung jederzeit möglich. <a href="/policies/privacy-policy" style="color:#666;text-decoration:underline">Datenschutz</a></p>';
    grid.parentNode.insertBefore(box, grid);

    var form = box.querySelector('form'), msg = box.querySelector('.vora-nl-msg');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = form.email.value.trim();
      function show(t, ok) { msg.textContent = t; msg.style.display = 'block'; msg.style.color = ok ? '#1a7f37' : '#c00'; }
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { show('Bitte gib eine gültige E-Mail-Adresse ein.', false); return; }
      var btn = form.querySelector('button'); btn.disabled = true; btn.textContent = 'Einen Moment …';
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + COMPANY, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
        body: JSON.stringify({ data: { type: 'subscription', attributes: {
          custom_source: 'Landingpage Kreatin fuer Frauen',
          profile: { data: { type: 'profile', attributes: {
            email: email,
            subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
          } } }
        }, relationships: { list: { data: { type: 'list', id: LIST } } } } })
      }).then(function (r) {
        if (!r.ok) throw new Error(r.status);
        form.style.display = 'none';
        show('Fast geschafft! Bitte bestätige deine Anmeldung in deinem Postfach. Danach kommt dein 10 %-Code per Mail.', true);
      }).catch(function () {
        btn.disabled = false; btn.textContent = '10 % SICHERN';
        show('Das hat nicht geklappt. Bitte versuch es noch einmal.', false);
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', build); else build();
})();
